import type { SVGProps } from "react";

/**
 * arrow-up-right
 * @category Arrows
 */
export default function IconArrowUpRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M18.25 15.25V5.75M18.25 5.75H8.75M18.25 5.75L6 18'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
